'use client';
import { useContext } from 'react';
import * as React from 'react';
import { LinkContext } from '../../../util/LinkContext';

type LinkProps = {
  href: string;
  passHref?: boolean;
  children: React.ReactNode;
};

const Link: React.FC<LinkProps> = ({ children, href, passHref = true }) => {
  const NextLink = useContext(LinkContext);

  if (NextLink) {
    return (
      <NextLink href={href} passHref={passHref} legacyBehavior>
        {children}
      </NextLink>
    );
  }

  return (
    <>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child) && child.type === 'a') {
          const childProps =
            child.props as React.AnchorHTMLAttributes<HTMLAnchorElement>;
          return (
            <a {...childProps} href={href}>
              {childProps.children}
            </a>
          );
        }
        return child;
      })}
    </>
  );
};

export default Link;
